import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { JwtService } from 'app/core';
import { SurveyService } from './survey.service';
import { AuthService } from 'app/auth';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
  private token: string = null;

  // options for radio button
  public options: any = [
    { label: '', value: 'yes' },
    { label: '', value: 'no' }
  ];

  // labels for checkbox
  public labels: any = [
    { check1: '' },
    { check2: '' },
    { check3: '' },
    { check4: '' },
    { check5: '' },
    { labelButton: '' },
    { labelTextarea: '' },
    { placeholderTextarea: '' }
  ];

  public question1: string;
  public question2: string;
  public question3: string;
  public selectOptions: string;
  public step1: string;
  public step2: string;
  public step3: string;
  public errorText: string;
  public feedbackText: string;

  // true when survey is done
  public done: boolean = false;

  // true if survey was already answered
  public error: boolean = false;

  // results of survey
  private results: any = {
    question1: {
      questionId: 'question1',
      value: ''
    },
    question2: {
      questionId: 'question2',
      value: ''
    },
    question3: {
      questionId: 'question3',
      value: []
    }
  };

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    public jwtService: JwtService,
    public surveyService: SurveyService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParams: Params) => {
      this.results.question1.value = queryParams['firstAnswer'];
      this.token = queryParams['token'];
      const lang = ['de', 'en', 'es', 'fr', 'pt', 'nl'].includes(queryParams['lang'])
        ? queryParams['lang']
        : 'en';
      this.translate.use(lang).subscribe(() => {
        this.translate.getTranslation(lang).subscribe((translations) => {
          this.setTranslations(translations);
        });
      });
    });
  }

  public setTranslations(translations: any): void {
    this.options = [
      { label: translations.nouns.yes, value: 'yes' },
      { label: translations.nouns.no, value: 'no' }
    ];
    this.labels = [
      { check1: translations.survey.check1 },
      { check2: translations.survey.check2 },
      { check3: translations.survey.check3 },
      { check4: translations.survey.check4 },
      { check5: translations.survey.check5 },
      { labelButton: translations.survey.labelButton },
      { labelTextarea: translations.survey.labelTextarea },
      { placeholderTextarea: translations.survey.placeholderTextarea }
    ];
    this.question1 = translations.survey.question1;
    this.question2 = translations.survey.question2;
    this.question3 = translations.survey.question3;
    this.selectOptions = translations.survey.selectOptions;
    this.step1 = translations.survey.step1;
    this.step2 = translations.survey.step2;
    this.step3 = translations.survey.step3;
    this.errorText = translations.survey.error;
    this.feedbackText = translations.survey.feedback;
  }

  public changeFirstAnswer(event: any): void {
    this.results.question1.value = event.detail.value;
  }

  public changeSecondAnswer(event: any): void {
    this.results.question2.value = event.detail.value;
  }

  public changeThirdAnswer(option: string): void {
    const optionIndex = this.results.question3.value.indexOf(option);
    if (optionIndex === -1) {
      this.results.question3.value.push(option);
    } else {
      this.results.question3.value.splice(optionIndex, 1);
    }
  }

  public changeTextAnswer(event: any): void {
    this.results.question3.other = event.detail.value;
  }

  public async submit(): Promise<any> {
    const verifyedToken = await this.authService.verifyToken(this.token);
    const { licenseId } = verifyedToken;
    const results = Object.values(this.results);
    try {
      const scopedToken = await this.authService.verifyTokenAndGenerateScopedToken(this.token);
      this.jwtService.saveToken(scopedToken.token);
      this.surveyService.createApplicabilitySurvey({ licenseId, results }).subscribe({
        next: () => {
          this.done = true;
        },
        error: () => {
          this.done = true;
          this.error = true;
        }
      });
    } catch (error) {
      this.done = true;
      this.error = true;
    }
  }
}
